export default "__VITE_ASSET__7e0aa2ca__"